const KEY = 'enterprise_salon_service_work_pins';

function readPins() {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writePins(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, 40)));
  } catch {
    /* ignore */
  }
}

/** Remember stylist ↔ visit work on this device (survives refresh / logout local clear). */
export function pinServiceWork({ checkinId, customerCode, customerName, stylistId, stylistName }) {
  const id = String(checkinId || '').trim();
  const sid = String(stylistId || '').trim();
  if (!id) return;
  const pins = readPins().filter(
    (p) => !(String(p.checkinId) === id && String(p.stylistId || '') === sid),
  );
  pins.unshift({
    checkinId: id,
    customerCode: customerCode || '',
    customerName: customerName || '',
    stylistId: sid,
    stylistName: stylistName || '',
    updatedAt: new Date().toISOString(),
  });
  writePins(pins);
}

export function pinsForCheckin(checkinId, allPins = null) {
  const id = String(checkinId || '').trim();
  const list = allPins || readPins();
  return list.filter((p) => String(p.checkinId) === id);
}

export function listServiceWorkPins() {
  return readPins();
}

export function removeServiceWorkPin(checkinId, stylistId) {
  const id = String(checkinId || '').trim();
  const sid = stylistId != null ? String(stylistId || '').trim() : '';
  writePins(
    readPins().filter((p) => {
      if (String(p.checkinId) !== id) return true;
      if (!sid) return false;
      return String(p.stylistId || '') !== sid;
    }),
  );
}

export function clearServiceWorkPins() {
  writePins([]);
}

export function todayIstDateKey() {
  return new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });
}

/** Drop device pins that no longer exist on the server (e.g. after DB purge). */
export function syncServiceWorkPinsWithServerVisits(openVisits = [], finishedVisits = []) {
  const valid = new Set();
  for (const row of [...openVisits, ...finishedVisits]) {
    const id = String(row?.id || '').trim();
    if (id) valid.add(id);
  }
  const next = readPins().filter((p) => valid.has(String(p.checkinId || '')));
  writePins(next);
  return next;
}
